import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentTemplate, TitleHeader } from 'web-library';
import CandidateProfileRequestForAmendmentDetails from '../../../modules/profile/components/CandidateProfileRequestForAmendmentDetails';

const CandidateProfileRequestForAmendment = () => {
  const { t } = useTranslation();
  return (
    <>
      <TitleHeader title={t('profile->>CreateCandidateForm.RequestForAmendment')} />
      <ContentTemplate type="full">
        <CandidateProfileRequestForAmendmentDetails />
      </ContentTemplate>
    </>
  );
};

export default CandidateProfileRequestForAmendment;
